import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { API } from '../../App';
import { toast } from 'sonner';

const HealthChatTab = () => {
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [chatSessionId, setChatSessionId] = useState(null);
  const [loading, setLoading] = useState(false);

  const sendChatMessage = async () => {
    if (!chatInput.trim()) return;
    const userMessage = chatInput.trim();
    setChatInput('');
    setChatMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setLoading(true);
    try {
      const response = await axios.post(`${API}/chatbot/message`, { session_id: chatSessionId, message: userMessage });
      if (response.data.session_id && !chatSessionId) setChatSessionId(response.data.session_id);
      setChatMessages(prev => [...prev, { role: 'assistant', content: response.data.response }]);
    } catch (error) {
      setChatMessages(prev => [...prev, { role: 'assistant', content: 'Sorry, I encountered an error. Please try again.' }]);
    } finally { setLoading(false); }
  };

  return (
    <Card className="p-6" data-testid="health-chat-tab">
      <h2 className="text-2xl font-bold text-green-600 mb-6">AI Health Chat</h2>
      <div className="bg-gray-50 rounded-lg p-4 mb-4 h-96 overflow-y-auto">
        {chatMessages.length === 0 ? (
          <div className="text-center text-gray-500 mt-12">
            <p className="text-lg mb-2">Ask me anything about health!</p>
            <p className="text-sm">I can help with symptoms, medications, diet, exercise, and more.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {chatMessages.map((msg, idx) => (
              <div key={`chat-${idx}`} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                <div className={`max-w-[80%] rounded-lg p-3 ${msg.role === 'user' ? 'bg-green-600 text-white' : 'bg-white border border-gray-200'}`}>
                  <p className="text-sm whitespace-pre-wrap">{msg.content}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <form onSubmit={(e) => { e.preventDefault(); sendChatMessage(); }} className="flex gap-2">
        <input value={chatInput} onChange={(e) => setChatInput(e.target.value)} placeholder="Type your health question..." className="flex-1 px-4 py-2 border rounded-lg" disabled={loading} />
        <Button type="submit" disabled={loading || !chatInput.trim()} className="bg-green-600 hover:bg-green-700" data-testid="send-chat-btn">
          {loading ? 'Sending...' : 'Send'}
        </Button>
      </form>
    </Card>
  );
};

export default HealthChatTab;
